import { render, staticRenderFns } from "./PresentationUpload.vue?vue&type=template&id=5c37cf00&scoped=true"
import script from "./PresentationUpload.vue?vue&type=script&lang=js"
export * from "./PresentationUpload.vue?vue&type=script&lang=js"
import style0 from "./PresentationUpload.vue?vue&type=style&index=0&id=5c37cf00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c37cf00",
  null
  
)

export default component.exports